import {
  Grid,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';

import { footerImageOffset } from 'components/Footer/styles';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import * as S from './styles';

import ChiaraImgDesktop from '/public/images/founders/desktop/chiara_frigerio.jpg';
import DavideImgDesktop from '/public/images/founders/desktop/davide_barenghi.jpg';
import TommiImgDesktop from '/public/images/founders/desktop/tommaso_de_mojana.jpg';
import ChiaraImg from '/public/images/founders/mobile/chiara_frigerio.jpg';
import DavideImg from '/public/images/founders/mobile/davide_barenghi.jpg';
import TommiImg from '/public/images/founders/mobile/tommaso_de_mojana.jpg';

interface Founder {
  name: string;
  position: string;
  description: string;
}
interface Props {
  founders: Founder[];
}

export const Founders: React.FC<Props> = ({ founders }) => {
  const { greaterThan } = useViewport();

  const textAlignment = greaterThan('tablet') ? 'left' : 'center';

  const foundersImg = () => {
    if (greaterThan('tablet')) {
      return [DavideImgDesktop, ChiaraImgDesktop, TommiImgDesktop];
    }

    return [DavideImg, ChiaraImg, TommiImg];
  };

  return (
    <SectionWrapper
      backgroundColor="neutral_extra_light"
      id="founders"
      paddingBottom={greaterThan('tablet') ? 'xxlarge' : 'xlarge'}
      additionalPadding={footerImageOffset}
    >
      <Grid.Wrapper>
        <Typography variant="heading_2" marginBottom="small">
          The Founders
        </Typography>

        <Typography>
          Lami nasce dalla visione di un team di imprenditori e amici di lunga
          data con diversi background ed esperienze internazionali uniti
          dall’obiettivo di rivoluzionare il paradigma della primary care.
        </Typography>

        <S.Grid>
          {founders.map((founder, i) => (
            <S.Card key={`value-${i}`}>
              <S.FounderImage
                src={foundersImg()[i]}
                alt="Founder Profile Image"
                quality={100}
                placeholder="blur"
              />

              <S.Content>
                <S.Typography
                  marginBottom="none"
                  fontWeight="medium"
                  textAlign={textAlignment}
                >
                  {founder.name}
                </S.Typography>

                <S.Typography
                  marginBottom="none"
                  variant="body_text_3"
                  textAlign={textAlignment}
                >
                  {founder.position}
                </S.Typography>
              </S.Content>
            </S.Card>
          ))}
        </S.Grid>
      </Grid.Wrapper>
    </SectionWrapper>
  );
};

export default Founders;
